export const productTypes = [
  {
    intProductTypeID: "1",
    vchProductTypeName: "Italian Ice",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Italian Ice",
    bitActive: "Active",
  },
  {
    intProductTypeID: "2",
    vchProductTypeName: "Cream Ice",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Cream Ice",
    bitActive: "Active",
  },
  {
    intProductTypeID: "3",
    vchProductTypeName: "Gelati",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Gelati",
    bitActive: "Active",
  },
  {
    intProductTypeID: "4",
    vchProductTypeName: "Misto",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Misto",
    bitActive: "Active",
  },
  {
    intProductTypeID: "5",
    vchProductTypeName: "Custard",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Sundae",
    bitActive: "Active",
  },
  {
    intProductTypeID: "6",
    vchProductTypeName: "Blendini/Concrete",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Blendini",
    bitActive: "Active",
  },
  {
    intProductTypeID: "7",
    vchProductTypeName: "Hand-Scooped Custard",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Hand Crafted Custard",
    bitActive: "Active",
  },
  {
    intProductTypeID: "8",
    vchProductTypeName: "Sugar-Free",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Sugar-Free",
    bitActive: "Active",
  },
  {
    intProductTypeID: "14",
    vchProductTypeName: "Alex's Lemonade",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Alex's Lemonade",
    bitActive: "Active",
  },
  {
    intProductTypeID: "15",
    vchProductTypeName: "Additional Toppings",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Miscellaneous",
    bitActive: "Active",
  },
  {
    intProductTypeID: "17",
    vchProductTypeName: "Ritaccino",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Ritaccino",
    bitActive: "Active",
  },
  {
    intProductTypeID: "20",
    vchProductTypeName: "Snacks",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Pretzel",
    bitActive: "Active",
  },
  {
    intProductTypeID: "25",
    vchProductTypeName: "Catering (Bulk Ice)",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Catering",
    bitActive: "Active",
  },
  {
    intProductTypeID: "32",
    vchProductTypeName: "Slenderita",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Slenderita",
    bitActive: "Active",
  },
  {
    intProductTypeID: "34",
    vchProductTypeName: "Frozen Custard Cakes",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Frozen Custard Cakes",
    bitActive: "Active",
  },
  {
    intProductTypeID: "35",
    vchProductTypeName: "FDOSpring Sales Information",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "FDOSpring Sales Information",
    bitActive: "Active",
  },
  {
    intProductTypeID: "37",
    vchProductTypeName: "Cookie Sandwich Pack",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Cookie Sandwich Pack",
    bitActive: "Active",
  },
  {
    intProductTypeID: "38",
    vchProductTypeName: "Smoothies",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Smoothies",
    bitActive: "Active",
  },
  {
    intProductTypeID: "39",
    vchProductTypeName: "Cookies",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Cookies",
    bitActive: "Active",
  },
  {
    intProductTypeID: "40",
    vchProductTypeName: "Customizable Cakes",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Customizable Cakes",
    bitActive: "Active",
  },
  {
    intProductTypeID: "41",
    vchProductTypeName: "Beverages",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Beverages",
    bitActive: "Active",
  },
  {
    intProductTypeID: "42",
    vchProductTypeName: "Hot Drinks",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Hot Drinks",
    bitActive: "Active",
  },
  {
    intProductTypeID: "43",
    vchProductTypeName: "Mix-Ins",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Mix-Ins",
    bitActive: "Active",
  },
  {
    intProductTypeID: "44",
    vchProductTypeName: "FDOSummer Sales Information",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "FDOSummer Sales Information",
    bitActive: "Active",
  },
  {
    intProductTypeID: "45",
    vchProductTypeName: "Milkshakes",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Milkshakes",
    bitActive: "Active",
  },
  {
    intProductTypeID: "46",
    vchProductTypeName: "Sundaes",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Sundaes",
    bitActive: "Active",
  },
  {
    intProductTypeID: "47",
    vchProductTypeName: "Yogurt",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Yogurt",
    bitActive: "Active",
  },
  {
    intProductTypeID: "48",
    vchProductTypeName: "Frozen Beverages",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Frozen Drink",
    bitActive: "Active",
  },
  {
    intProductTypeID: "49",
    vchProductTypeName: "Snacks",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Snacks",
    bitActive: "Active",
  },
  {
    intProductTypeID: "50",
    vchProductTypeName: "Light Vanilla Custard",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Light Vanilla Custard",
    bitActive: "Active",
  },
  {
    intProductTypeID: "51",
    vchProductTypeName: "Fresh Baked Cookies",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Fresh Baked Treats",
    bitActive: "Active",
  },
  {
    intProductTypeID: "53",
    vchProductTypeName: "Cool Stuff Consumer Goods",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Cool Stuff Consumer Goods",
    bitActive: "Active",
  },
  {
    intProductTypeID: "54",
    vchProductTypeName: "Novelties",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Novelties",
    bitActive: "Active",
  },
  {
    intProductTypeID: "55",
    vchProductTypeName: "Topping",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Topping",
    bitActive: "Active",
  },
  {
    intProductTypeID: "56",
    vchProductTypeName: "Apparel",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Apparel",
    bitActive: "Active",
  },
  {
    intProductTypeID: "57",
    vchProductTypeName: "Apparel XXL",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Apparel XXL",
    bitActive: "Active",
  },
  {
    intProductTypeID: "58",
    vchProductTypeName: "Cakes",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Cakes",
    bitActive: "Active",
  },
  {
    intProductTypeID: "59",
    vchProductTypeName: "Cookie Sandwich 6-Pack",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Cookie Sandwich 6-Pack",
    bitActive: "Active",
  },
  {
    intProductTypeID: "60",
    vchProductTypeName: "Stuffing",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Stuffing",
    bitActive: "Active",
  },
  {
    intProductTypeID: "61",
    vchProductTypeName: "Smart All Discounts",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Smart All Discounts",
    bitActive: "Active",
  },
  {
    intProductTypeID: "62",
    vchProductTypeName: "Full Service Catering (Open $)",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Cool Catering",
    bitActive: "Active",
  },
  {
    intProductTypeID: "63",
    vchProductTypeName: "Shared Mobile Event - Non-Mobile Store",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Shared Catering",
    bitActive: "Active",
  },
  {
    intProductTypeID: "64",
    vchProductTypeName: "Frozen Coffee",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "",
    bitActive: "Active",
  },
  {
    intProductTypeID: "65",
    vchProductTypeName: "FDOSpring Cups",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "",
    bitActive: "Active",
  },
  {
    intProductTypeID: "66",
    vchProductTypeName: "Other Sales Information",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "",
    bitActive: "Active",
  },
  {
    intProductTypeID: "68",
    vchProductTypeName: "Wrigley Gum",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Wrigley Gum",
    bitActive: "Active",
  },
  {
    intProductTypeID: "69",
    vchProductTypeName: "Cookie Sandwich Pack w/Topping",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "",
    bitActive: "Active",
  },
  {
    intProductTypeID: "70",
    vchProductTypeName: "Cookie Sandwich Variety Pack",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "",
    bitActive: "Active",
  },
  {
    intProductTypeID: "71",
    vchProductTypeName: "Better for You",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Better for You",
    bitActive: "Active",
  },
  {
    intProductTypeID: "72",
    vchProductTypeName: "Custard Cup Test",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Custard Cup Test",
    bitActive: "Active",
  },
  {
    intProductTypeID: "74",
    vchProductTypeName: "Non-Mapped Product",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "NMP",
    bitActive: "Active",
  },
  {
    intProductTypeID: "75",
    vchProductTypeName: "Fundraiser Cards",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Fundraiser Cards",
    bitActive: "Active",
  },
  {
    intProductTypeID: "76",
    vchProductTypeName: "Smoothie Ice",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Smoothie Ice",
    bitActive: "Active",
  },
  {
    intProductTypeID: "77",
    vchProductTypeName: "Smoothie Ice Smoothies",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Smoothie Ice Smoothies",
    bitActive: "Active",
  },
  {
    intProductTypeID: "78",
    vchProductTypeName: "Non Revenue Product",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "NRP",
    bitActive: "Active",
  },
  {
    intProductTypeID: "79",
    vchProductTypeName: "Discount",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Discount",
    bitActive: "Active",
  },
  {
    intProductTypeID: "80",
    vchProductTypeName: "Test - Snacks",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Test - Snacks",
    bitActive: "Active",
  },
  {
    intProductTypeID: "81",
    vchProductTypeName: "Sandellas",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Sandellas",
    bitActive: "Active",
  },
  {
    intProductTypeID: "82",
    vchProductTypeName: "Reserved",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "",
    bitActive: "Active",
  },
  {
    intProductTypeID: "83",
    vchProductTypeName: "Acai",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Acai",
    bitActive: "Active",
  },
  {
    intProductTypeID: "85",
    vchProductTypeName: "Fresh Baked Treats",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Freshly Baked Cookies",
    bitActive: "Active",
  },
  {
    intProductTypeID: "86",
    vchProductTypeName: "Nathans",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Nathans",
    bitActive: "Active",
  },
  {
    intProductTypeID: "87",
    vchProductTypeName: "Donuts",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Donuts",
    bitActive: "Active",
  },
  {
    intProductTypeID: "88",
    vchProductTypeName: "Donut Desserts",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Donut Desserts",
    bitActive: "Active",
  },
  {
    intProductTypeID: "90",
    vchProductTypeName: "Cafe Add-On's",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Cafe Add-On's",
    bitActive: "Active",
  },
  {
    intProductTypeID: "99",
    vchProductTypeName: "Non-Coded Revenue Sales",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "",
    bitActive: "Active",
  },
  {
    intProductTypeID: "101",
    vchProductTypeName: "Stadium Snacks",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Stadium Snacks",
    bitActive: "Active",
  },
  {
    intProductTypeID: "102",
    vchProductTypeName: "Hand Scooped Custard",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Hand Scooped Custard",
    bitActive: "Active",
  },
  {
    intProductTypeID: "103",
    vchProductTypeName: "Frozen Tea",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Frozen Tea",
    bitActive: "Active",
  },
  {
    intProductTypeID: "104",
    vchProductTypeName: "Malt Milkshake",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Malt Milkshake",
    bitActive: "Active",
  },
  {
    intProductTypeID: "105",
    vchProductTypeName: "Soups",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Soups",
    bitActive: "Active",
  },
  {
    intProductTypeID: "106",
    vchProductTypeName: "3rd Party Delivery",
    bitIncludeInStoreMenu: "1",
    vchDMBName: "Open Delivery",
    bitActive: "Active",
  },
  {
    intProductTypeID: "107",
    vchProductTypeName: "Donut Catering",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Donut Catering",
    bitActive: "Active",
  },
  {
    intProductTypeID: "109",
    vchProductTypeName: "Consumer Goods Store Exception",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "",
    bitActive: "Active",
  },
  {
    intProductTypeID: "110",
    vchProductTypeName: "Good to Go",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "",
    bitActive: "Active",
  },
  {
    intProductTypeID: "111",
    vchProductTypeName: "Smoothie",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "",
    bitActive: "Active",
  },
  {
    intProductTypeID: "112",
    vchProductTypeName: "Online Ordering",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Online Ordering",
    bitActive: "Active",
  },
  {
    intProductTypeID: "114",
    vchProductTypeName: "Grab and Go",
    bitIncludeInStoreMenu: "0",
    vchDMBName: "Grab and Go",
    bitActive: "Active",
  },
];
